
    export const BuildCommit = '1a2ed5677f60f3c73dc01b6f1e2a287e3b44d80e';
    export const BuildVersion = '3.0.3';
